import * as React from "react";

function Language(props) {
  return (
    <svg
      viewBox="0 0 34 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Language"
      {...props}
    >
      <path
        d="M23.8 6.054c.584 0 1.063.436 1.063 1.075v.215h3.187c.584 0 1.063.436 1.063 1.076 0 .591-.479 1.075-1.063 1.075h-.106l-.085.242c-.473 1.268-1.196 2.505-2.11 3.515.049.027.096.011.144.086l1.004.608c.505.306.664.968.361 1.478-.297.51-.95.672-1.455.366l-1.004-.608c-.234-.145-.516-.295-.696-.457-.558.404-1.164.753-1.801 1.043l-.197.086a1.058 1.058 0 01-1.402-.548 1.08 1.08 0 01.542-1.42l.19-.085c.34-.156.67-.377.984-.527l-.643-.656a1.07 1.07 0 010-1.516 1.04 1.04 0 011.498 0l.776.78.032-.016c.658-.656 1.195-1.473 1.583-2.42h-5.69c-.632 0-1.063-.435-1.063-1.075 0-.591.43-1.075 1.063-1.075h2.762v-.215c0-.591.43-1.075 1.063-1.075v.048zM8.5 9.774l1.01 2.301H7.442l1.057-2.3zM0 4.12c0-1.9 1.522-3.44 3.4-3.44h27.2c1.875 0 3.4 1.54 3.4 3.44v13.762c0 1.898-1.525 3.44-3.4 3.44H3.4c-1.878 0-3.4-1.542-3.4-3.44V4.119zm17 13.762h13.6V4.119H17v13.762zM9.472 6.694a1.067 1.067 0 00-.972-.64c-.42 0-.802.253-.972.64l-3.4 7.741c-.237.495.004 1.177.54 1.42a1.06 1.06 0 001.404-.549l.473-1.129h3.91l.473 1.129c.239.543.866.79 1.402.548.537-.242.781-.924.542-1.419l-3.4-7.741z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Language;